import fwUtil from 'framework-util'



export function getLastYearEventService(data) {
  return custemRequest({
    url: 'fwYjzhEvent/lastYear',
    method: 'get',
    params:data
  })
}

export function getMarkerService(data){

  return custemRequest({
    url: 'custom/map/getData',
    method: 'get',
    params:data
  })
}



// WEBPACK FOOTER //
// ./src/api/chart/chart/fwYjzhEvent.js